import {
  getAsyncSelectShowSelectedApiParamIdPK,
  InputMultiSelectControl,
  MultiSelect,
  SelectDropdownListFooter,
  SelectDropdownListHeader,
} from '../../Select'
import { CategorySelect } from '../CategorySelect'

import { CATEGORY_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG_SELECT_ALL } from './CategoryMultiSelect.constants'

function CategoryMultiSelect({
  Control = InputMultiSelectControl,
  dropdownFloatingConfig = CATEGORY_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG_SELECT_ALL,
  getShowSelectedApiParam = getAsyncSelectShowSelectedApiParamIdPK,
  listProps,
  tagsProps,
  onClear,
  onSelectItem,
  ...restProps
}) {
  return (
    <MultiSelect
      {...restProps}
      Control={Control}
      Select={CategorySelect}
      dropdownFloatingConfig={dropdownFloatingConfig}
      getShowSelectedApiParam={getShowSelectedApiParam}
      listProps={{
        ...listProps,
        Footer: listProps?.SelectDropdownListFooter || SelectDropdownListFooter,
        Header: listProps?.SelectDropdownListHeader || SelectDropdownListHeader,
      }}
      tagsProps={{
        ...tagsProps,
        onChange: onSelectItem,
        onClear,
      }}
      onClear={onClear}
      onSelectItem={onSelectItem}
    />
  )
}

export default CategoryMultiSelect
